import createPerquisitesComponent from '../perquisitesComponents/createPerquisitesComponent';
import editPerquisitesComponent from '../perquisitesComponents/editPerquisitesComponent';
import createSalaryComponent from './mutations/createSalaryComponent';
import setSalaryComponentStatus from './mutations/setSalaryComponentStatus';
import updateAdditions from './mutations/updateAdditions';
import updateDeductions from './mutations/updateDeductions';
import updateEmployeesAdditionsDeductionsLop from './mutations/updateEmployeesAdditionsDeductionsLop';
import { updateFnfDetails } from './mutations/updateFnfDetails';
import { updateFnfDetailsV2 } from './mutations/updateFnfDetailsV2';
import updateSalaryComponent from './mutations/updateSalaryComponent';
import getEmployeeAdditionsDeductions from './queries/getEmployeeAdditionsDeductions';
import { getFnfDetails } from './queries/getFnfDetails';
import { getFnfDetailsV2 } from './queries/getFnfDetailsV2';
import { getDismissalDate } from './queries/getFnfDismissalDate';
import getSalaryComponent from './queries/getSalaryComponent';
import listAdditions from './queries/listAdditions';
import listDeductions from './queries/listDeductions';
import listSalaryComponents from './queries/listSalaryComponents';
import deleteVariableAdditions from './queries/deleteVariableAdditions';

const mutations = {
  setSalaryComponentStatus,
  updateSalaryComponent,
  createSalaryComponent,
  updateAdditions,
  updateDeductions,
  updateFnfDetails,
  updateFnfDetailsV2,
  updateEmployeesAdditionsDeductionsLop,
  createPerquisitesComponent,
  editPerquisitesComponent,
};

const queries = {
  listSalaryComponents,
  getSalaryComponent,
  listAdditions,
  getFnfDetails,
  getFnfDetailsV2,
  listDeductions,
  getEmployeeAdditionsDeductions,
  getDismissalDate,
  deleteVariableAdditions,
};

const exports = {
  mutations,
  queries,
};

export default exports;
